import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import resolveSilkPrintSideName from "../../../../../service/sideNameResolver/resolveSilkPrintSideName"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"
import isValidSilk from "../../../../service/visibleValidator/isValidSilk"
import SilkPrintPatternImage from "./SilkPrintPatternImage"

const 印刷する面 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { silk: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="印刷する面" helpURL={HELP_LINKS.印刷する面}>
      <RadioGroup
        name={FIELD_NAMES.印刷する面}
        selectedValue={values.silk}
        onChange={handlers.radio}
        shouldRender={(value) => isValidSilk(values, value)}
      >
        <OneClickFieldStack>
          <Radio
            value={ESTIMATE_CONSTANT.印刷する面["パターン面と同じ面(L1面)"].value}
            prefixNode={<SilkPrintPatternImage pattern="top" values={values} />}
          >
            {resolveSilkPrintSideName(ESTIMATE_CONSTANT.印刷する面["パターン面と同じ面(L1面)"].value, values)}
          </Radio>
          <Radio
            value={ESTIMATE_CONSTANT.印刷する面.両面.value}
            prefixNode={<SilkPrintPatternImage pattern="both" values={values} />}
          >
            両面
          </Radio>
          <Radio
            value={ESTIMATE_CONSTANT.印刷する面["パターン面とは逆の面(Ln面)"].value}
            prefixNode={<SilkPrintPatternImage pattern="bottom" values={values} />}
          >
            {resolveSilkPrintSideName(ESTIMATE_CONSTANT.印刷する面["パターン面とは逆の面(Ln面)"].value, values)}
          </Radio>
          <Radio
            value={ESTIMATE_CONSTANT.印刷する面.なし.value}
            prefixNode={<SilkPrintPatternImage pattern="none" values={values} />}
          >
            なし
          </Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.silk} />
    </OneClickField>
  )
}

export default 印刷する面
